import script from "./AssinaturaPendenteListaModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AssinaturaPendenteListaModal.vue?vue&type=script&setup=true&lang=js"

import "./AssinaturaPendenteListaModal.vue?vue&type=style&index=0&id=27ff26f5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27ff26f5"]])

export default __exports__